import React, { Suspense } from 'react';
import { routes } from '@/app/routes';
import { LOGIN_MENU_TYPES, forgotPasswordPhases } from '@/constants';
import * as login from './login-form-styles';
import { SignInForm } from './sign-in-form';

const OtherForm = React.lazy(() => import('./other-form'));
export class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // animation states
      rotateEnd: false,
      rotating: false,
      signInFadeOut: false,
      authFadeOut: true,
      // ----------------
      showOtherForm: false,
      currentMenu: LOGIN_MENU_TYPES.SSO_SIGN_IN,
    };
  }

  // Flips the form container and displays sets the form context
  handleShowOtherForm = (currentMenu) => {
    this.setState({ showOtherForm: true, currentMenu });
  };

  // Handles back button from first time user menu (activation)
  rotateBack = () => {
    this.setState({ showOtherForm: false });
  };

  /** ************************ Event Listeners **************************** */

  // Rotation Completed (end of 180deg turn)
  onRotateEnd = (e) => {
    if (e.propertyName === 'transform' && e.target.id === 'form-container') {
      this.setState({ rotateEnd: true, rotating: false });
    }
  };

  // SignIn Menu completed faded out
  onFadeOut = (e) => {
    if (
      e.propertyName === 'opacity' &&
      e.target.id === 'sign-in-animator' &&
      !this.state.authFadeOut
    ) {
      this.setState({ signInFadeOut: true });
    }
  };

  // Auth Menu Completed Fade Out
  onAuthFadeOut = (e) => {
    if (
      e.propertyName === 'opacity' &&
      e.target.id === 'other-form-animator' &&
      !this.state.signInFadeOut
    ) {
      this.setState({
        authFadeOut: true,
        currentMenu: LOGIN_MENU_TYPES.SIGN_IN,
      });
    }
  };

  // Rotation event began
  onRotationStart = (e) => {
    if (
      e.propertyName === 'transform' &&
      e.target.id === 'form-container' &&
      !this.state.rotating
    ) {
      if (this.state.signInFadeOut) {
        this.setState({
          rotating: true,
          rotateEnd: false,
          signInFadeOut: false,
        });
      } else {
        this.setState({ rotating: true, rotateEnd: false, authFadeOut: false });
      }
    }
  };

  /** ^^^^^^^^^^^^^^^^^^^^^^^^^^^^ Event Listeners ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ */

  // Assign listeners to DOM elements
  componentDidMount() {
    const formContainer = document.getElementById('form-container');
    const signInForm = document.getElementById('sign-in-animator');

    if (formContainer) {
      formContainer.addEventListener('transitionend', this.onRotateEnd, true);
      signInForm.addEventListener('transitionend', this.onFadeOut, true);
      formContainer.addEventListener(
        'transitionstart',
        this.onRotationStart,
        true
      );
    }

    if (this.props.possiblePwReset) {
      // User came to the login page from pw reset link
      this.setState({
        showOtherForm: true,
        currentMenu: LOGIN_MENU_TYPES.FORGOT_PASSWORD_PASSWORD,
      });
    }
  }

  handleForgotPasswordClicked = (passwordResetPhase) => {
    if (this.state.showOtherForm) {
      if (passwordResetPhase === forgotPasswordPhases.PASSWORD_SETUP) {
        this.props.history.push(routes.LOGIN);
        this.setState({ currentMenu: LOGIN_MENU_TYPES.SIGN_IN });
      } else {
        this.rotateBack();
        this.setState({ currentMenu: LOGIN_MENU_TYPES.FORGOT_PASSWORD_EMAIL });
      }
    } else {
      this.handleShowOtherForm(LOGIN_MENU_TYPES.FORGOT_PASSWORD_EMAIL);
    }
  };

  updateCurrentMenu = (currentMenu) => {
    this.setState({ currentMenu });
  };

  computeProperHeight = () => {
    const heightMap = {
      [LOGIN_MENU_TYPES.SSO_SIGN_IN]: '325px',
      [LOGIN_MENU_TYPES.SIGN_IN]: '455px',
      [LOGIN_MENU_TYPES.FORGOT_PASSWORD_EMAIL]: '350px',
      [LOGIN_MENU_TYPES.FORGOT_PASSWORD_PASSWORD]: '525px',
    };

    return heightMap[this.state.currentMenu] || '525px';
  };

  render() {
    const height = this.computeProperHeight();

    return (
      <React.Fragment>
        <login.FormContainer
          id="form-container"
          hideSignIn={this.state.showOtherForm}
          height={height}
        >
          <SignInForm
            authFadeOut={this.state.authFadeOut}
            showOtherForm={this.state.showOtherForm}
            handleForgotPasswordClicked={this.handleForgotPasswordClicked}
            updateCurrentMenu={this.updateCurrentMenu}
          />
          <Suspense fallback={<div>Loading...</div>}>
            <OtherForm
              signInFadeOut={this.state.signInFadeOut}
              showOtherForm={this.state.showOtherForm}
              emailSubmit={this.handleUserSubmittedEmail}
              possiblePwReset={this.props.possiblePwReset}
              rotateBack={this.rotateBack}
              currentMenu={this.state.currentMenu}
              onAuthFadeOut={this.onAuthFadeOut}
              goToLogin={this.handleForgotPasswordClicked}
              updateCurrentMenu={this.updateCurrentMenu}
            />
          </Suspense>
        </login.FormContainer>
      </React.Fragment>
    );
  }
}
